import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/features/auth/store'

interface RequireAuthProps {
  children: React.ReactNode
}

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return Date.now() >= payload.exp * 1000
  } catch {
    return true
  }
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const { accessToken, clearAuth } = useAuthStore()
  const location = useLocation()

  if (!accessToken || isTokenExpired(accessToken)) {
    if (accessToken) clearAuth()
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
